export default "__VITE_ASSET__BZbQAErF__"